// removed by extract-text-webpack-plugin
module.exports = {"wrapper-border-radius":"magazines_2FW_n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/editors/BorderRadius/styles.scss
// module id = 1220
// module chunks = 1